import React, { Requireable } from "react";
import PropTypes from "prop-types";
import * as ReactDOM from "react-dom/client";
import reactToWebComponent from "react-to-webcomponent";
import Page from "./Page";

class WebComponentWrapper extends React.Component<{},{}> {

  static propTypes: {
    name: Requireable<string>,
    description: Requireable<string>,
  }

  render() {
    return (
      <Page name='' age={5} />
    )
  }
}

WebComponentWrapper.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string
}

const SinglePager = reactToWebComponent(WebComponentWrapper, React, ReactDOM);

customElements.define("flows-one-pager", SinglePager);